import makeError from "make-error";

export const HTTPError = makeError('HTTP Error')

export const EventNotActiveError = makeError('Event not Active')